var map = {
	"./Anniversary Celebration - 2 - 1080_1080.webp": 5784,
	"./Baby Shower - 3 - 1080_1080.webp": 4395,
	"./Birthday Party - 5 - 1080_1080.webp": 5992,
	"./Community Event - 1 - 1080_1080.webp": 5042,
	"./Family Get-Together - 8 - 1080_1080.webp": 941,
	"./Festival Party - 9 - 1080_1080.webp": 65,
	"./Housewarming Celebration - 1 - 1080_1080.webp": 6886,
	"./Naamkaran Ceremony - 11 - 1080_1080.webp": 8272,
	"./Private Parties - 10 - 1080_1080.webp": 9112,
	"./Proposal Party - 11 - 1080_1080.webp": 3670,
	"./Religious & Traditional Event - 7 - 1080_1080.webp": 7073,
	"./Ring Ceremony - 7 - 1080_1080.webp": 3635,
	"./Social Event Banner - 6 - 1920_1080.webp": 4306,
	"./Wedding Planning - 11 - 1080_1080.webp": 959,
	"./Welcome Party - 11 - 1080_1080.webp": 5386,
	"./Why Choose Panthi Event - 1 - 1280_720.webp": 9334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 523;